// LIBRARIES
import styled, { css } from "styled-components";
import CancelIcon from "@mui/icons-material/Cancel";
import Button from "@mui/material/Button";
import LockIcon from "@mui/icons-material/Lock";

// MISC
import { COLORS, FONTS } from "constants/styleVariables";

export const ModalContainer = styled.div`
  height: 100%;
  width: 600px;
  // width: 90%;
  height: 100%;
  justify-content: center;
  border-bottom-left-radius: 24px;
  border-top-left-radius: 24px;
  background-color: #F5F5F5;
  position: absolute;
  right: 0%;
  display: flex;
  flex-direction: column;
  outline: none;
  padding: 80px;
  @media screen and (max-width: 830px) {
    width: 100%;
    padding: 40px;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
`;

export const IconContainer = styled.div`
  width: 56px;
  height: 56px;
  background-color: #293462;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HeaderIcon = styled.img`

`;



export const ContentInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 16px;
`;

export const HeaderTitle = styled.div`
font-size: 20px;
color: ${COLORS.primaryAppBlack};
font-family: ${FONTS.poppins};
letter-spacing: 0.8px;
font-weight: 600;
`;

export const HeaderSubtitle = styled.div`
font-size: 16px;
color: #B6B7BF;
font-family: ${FONTS.poppins};
letter-spacing: 0.64px;
font-weight: medium;
`;

export const SearchWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
`;

export const UsersList = styled.div`
  height: 380px;
  width: 520px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 3px;
  }
  ::-webkit-scrollbar-track {
    background-color: ${COLORS.backgroundColor};
    border-radius: 10px;
    margin-block: 9px;
    margin-left: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-image: linear-gradient(
      180deg,
      ${COLORS.rainbowIndigo} 0%,
      ${COLORS.rainbowIndigo} 100%
    );
`;

export const UserContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 47.8px;
  width: 520px;
  align-items: center;
  border-bottom: 3px solid #EAE8E8;
  cursor: pointer;
`;

export const CheckBox = styled.div(
  ({ isSelected }) => css`
  width: 16px;
  height: 16px;
  margin-right: 20px;
  border-radius: 50px;
  border: 1px solid ${COLORS.rainbowIndigo};
  background-color: ${isSelected ? COLORS.rainbowIndigo : "transparent"};
  `);

export const UserIcon = styled.div`
  width: 30px;
  height: 30px;
  margin-right: 12px;
  border-radius: 50px;
  background-color: ${COLORS.secondaryGray}
`;

export const UserName = styled.div`
  font-size: 16px;
  font-family: ${FONTS.montserrat};
  color: ${COLORS.rainbowIndigo};
  font-weight: 600;
  height: 48px;
  display: flex;
  align-items: center;
  `;

export const InputAtomContainer = styled.div(
  ({ width }) => css`
    // width: ${width ? width : "300px"};
    @media screen and (min-width: 1451px) {
      margin-right: 80px;
    }
    @media screen and (max-width: 1450px) {
      margin-right: 30px;
    }
    margin-bottom: 20px;
  `
);

export const CloseIconContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
`;

export const CloseIcon = styled(CancelIcon)`
  && {
    color: ${COLORS.thirdGray};
    padding: 0;
    margin-bottom: 0;
    cursor: pointer;
  }
`;
export const TitlesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled.div(
  ({ color }) => css`
    font-size: 30px;
    font-family: ${FONTS.newsharp};
    color: ${color ? color : COLORS.cornflowerBlue};
    font-weight: bold;
    text-align: center;
  `
);

export const CheckboxLine = styled.div`
  display: flex;
  flex-direction: row;
  // justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;

export const TitleContainer = styled.div(
  ({ color }) => css`
    display: flex;
    flex-direction: row;
    color: ${color ? color : COLORS.cornflowerBlue};
  `
);

export const LockerIcon = styled(LockIcon)(
  ({ color }) => css`
    && {
      margin-right: 10px;
      color: ${color ? color : COLORS.cornflowerBlue};
    }
    &.MuiSvgIcon-root {
      height: 33px;
    }
  `
);

export const Status = styled.text(
  ({ color }) => css`
    font-size: 22px;
    font-family: ${FONTS.montserrat};
    color: ${color ? color : COLORS.rainbowIndigo};
    font-weight: 600;
  `
);

export const EquipmentsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SubtitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 26px;
`;

export const Subtitle = styled.text`
  font-size: 20px;
  font-family: ${FONTS.montserrat};
  color: ${COLORS.secondaryBlack};
  font-weight: 600;
  margin-bottom: 20px;
  margin-top: 40px;
`;

export const Value = styled.text`
  font-size: 16px;
  font-family: ${FONTS.montserrat};
  color: ${COLORS.secondaryBlack};
  font-weight: 600;
  margin-top: 1px;
`;

export const EquipmentContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  line-height: 25px;
`;

export const EquipmentDescriptionContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const EquipmentName = styled.text`
  font-size: 16px;
  font-family: ${FONTS.newsharp};
  color: ${COLORS.secondaryBlack};
  font-weight: bold;
  margin-right: 20px;
`;

export const EquipmentStatus = styled.text(
  ({ color }) => css`
    font-size: 14px;
    font-family: ${FONTS.montserrat};
    color: ${color ? color : COLORS.primaryGreen};
    font-weight: 600;
  `
);

export const Bar = styled.div`
  height: 2px;
  background-color: ${COLORS.backgroundColor};
  margin: 10px 0;
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ButtonContainer = styled.div`
  margin: 0 auto;
  margin-top: 20px;
`;

export const ActionIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Icon = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 40px;
  cursor: pointer;
`;
